import React from "react";
import Notes from "./Notes";
import ProspectLeadNotes from "./ProspectLeadNotes";
import styles from "./Notes.module.css";
const NotesContainer = ({
  isApplicant,
  notes,
  id,
  refetch,
  isProspectLead,
  applicantLeadNotes,
}) => {
  return (
    <>
      {isProspectLead ? (
        <div className={styles["notes-leadProspect-cont"]}>
          <Notes notes={notes} refetch={refetch} id={id} isApplicant={isApplicant} />
          <ProspectLeadNotes
            applicantLeadNotes={applicantLeadNotes}
            refetch={refetch}
            id={id}
          />
        </div>
      ) : (
        <Notes notes={notes} refetch={refetch} id={id} isApplicant={isApplicant}/>
      )}
    </>
  );
};

export default NotesContainer;
